import { combineReducers } from 'redux';
import dashboardReducer from 'reducers/dashboard-reducer';
import propertyReducer from 'reducers/property-reducer';
import loginReducer from 'reducers/login-reducer';
import demandPartnersReducer from 'reducers/demand-partners-reducer';
import augmentationReducer from 'reducers/augmentation-reducer';
import guestRoomsReducer from './guestRoomsReducer';
import modalReducer from './modalReducer';

// combines all the reducers used into one reducer
const appReducer = combineReducers({
  dashboardReducer,
  propertyReducer,
  augmentationReducer,
  loginReducer,
  demandPartnersReducer,
  guestRoomsReducer,
  modalReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_SUCCESS') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
